import { useEffect } from 'react'

import { useSetState } from '@domain-group/react-hooks'

import api from '@functions/api'
import type { PublicationEditionModel } from '@models/types'

type DefaultState = {
  loading: boolean,
  publicationEditions: PublicationEditionModel[],
}

type SetState = (state: Partial<DefaultState>) => void

const fetchPublicationEditions = (setState: SetState) => {
  const requestOptions = {
    include_publication_edition_deadlines: true,
    include_publication_edition_publication: true,
    include_publication_edition_order_item_count: true,
  }

  setState({ loading: true })

  api('/publication_editions/upcoming_deadlines', requestOptions)
    .then(({ data }: { data: PublicationEditionModel[] }) => setState({ loading: false, publicationEditions: data }))
    .catch(() => setState({ loading: false }))
}

const defaultState: DefaultState = {
  loading: true,
  publicationEditions: [],
}

const useUpcomingPaginations = (options: { performHttpRequests?: boolean } = {}) => {
  const { performHttpRequests } = options

  const [state, setState] = useSetState(defaultState)
  const { loading, publicationEditions } = state

  useEffect(() => {
    if (performHttpRequests) fetchPublicationEditions(setState)
  }, [performHttpRequests])

  const filteredPublicationEditions = publicationEditions.filter(edition => !!edition.deadlines?.next_up)

  return {
    hasPublicationEditions: !!publicationEditions.length,
    loading,
    publicationEditions: filteredPublicationEditions,
  }
}

export default useUpcomingPaginations
